<template>
    <!-- 検索パーツ（小） -->
    <div class="pt030" id="pt030" v-cloak>
        <!-- 商品検索  -->
        <div class="itemTitle">
            <img class="itemIcon"/>
            <span>{{$t('pt030.labels.productSearch')}}</span>
        </div>
        <div class="search">
            <div v-if="errMsg != ''" class="errorMessage">
                {{errMsg}}
            </div>
            <div class="searchInput">
                <!-- 商品名・商品番号 -->
                <input v-model="pt030ReqModel.searchItemNm" @keydown.enter="pt030Search" id="itemNm" name="itemNm" maxlength="250" type="text" class="itemNmInput" :placeholder="$t('pt030.labels.productNm&ItemNum')">
                <div class="searchBtn">
                    <!-- 検索 -->
                    <input class="btnSubmit" :value="$t('common.buttons.search')" @click="pt030Search()" type="button">
                </div>
                <div class="searchDetailBtn">
                    <!-- 詳細検索 -->
                    <input class="btnSubmit" :value="$t('common.buttons.detailSearch')" @click="pt030SearchDetails()" type="button">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import SiteConstants from 'assets/const/SiteConstants.json';
export default {
    name: "PT030ProductSearchParts",
    data() {
        return {
            errMsg: '',
            pt030ReqModel:{},
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
    },
    methods: {
        /*
        * goto pg030
        */
        pt030Search: function(){
            if(this.pt030ReqModel.searchItemNm == '' || this.pt030ReqModel.searchItemNm == null || this.pt030ReqModel.searchItemNm == undefined){
                // 検索条件は必須です。
                this.errMsg = this.$i18n.t('pt030.labels.validMsg');
            }else{
                this.pt030ReqModel.pageNo = 2;
                this.$router.push({ name: this.SiteConstants.PG010MAIN, query: this.pt030ReqModel});
            }
        },
        pt030SearchDetails: function(){
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query:{pageNo:13}});
        },
    },
    created(){
        var _this = this;
        // Get data from params and query
        var queryData = _this.$route.query;

        if(Object.keys(queryData).length > 0){
            _this.pt030ReqModel.searchItemNm = queryData.searchItemNm;
        }
    }
}
</script>